import { OrdersService } from './../../../services/order/orders.service';
import { Subscription } from 'rxjs';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PdvService } from '../../../services/pdv/pdv.service';

@Component({
    selector: 'menu-card',
    templateUrl: 'menu.component.html',
    styleUrls: ['menu.component.scss']
})

export class MenuComponent{

    @Input()
    menu;
    loadAvatar = false;
    @Output()
    OnAdd:EventEmitter<boolean>=new EventEmitter<boolean>(); 
    addToBasket(){
        this.OnAdd.emit(true);
    }
    siteClose = false;
    subscriptions2: Subscription[] = [];
    orderName:string="";
    constructor(private pdvService:PdvService,private orderService:OrdersService){
        
    }

    ngOnInit(){
        let sub=this.pdvService.pdv.subscribe(
            (data)=>{
                this.siteClose=data.closeSite;
            }
        )
        const subs1 = this.orderService.chosenOrderType.subscribe((orderType: number) => {
            switch(orderType){
                case 1: this.orderName='Delivery';break;
                case 2: this.orderName='On the spot';break;
                case 3: this.orderName='To take away';break;
            }
        })
        this.subscriptions2.push(sub,subs1);
    }
    
    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }
    ngOnDestroy() {
        this.unsubscribe2();
    }
}
